import { useEffect, useState } from 'react';
import i18n from '../lib/i18n';
import { useIsClient } from '../lib/hooks/useHydration';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'de', label: 'Deutsch' },
];

function detectBrowserLanguage(): string {
  if (typeof navigator === 'undefined') return 'en';
  const lang = navigator.language || (navigator as any).userLanguage || 'en';
  const short = lang.split('-')[0].toLowerCase();
  return ['en', 'es', 'de'].includes(short) ? short : 'en';
}

export default function LanguageSelector() {
  const [selected, setSelected] = useState<string>('en');
  const isClient = useIsClient();

  useEffect(() => {
    if (isClient) {
      try {
        const stored = localStorage.getItem('lang');
        const initial = stored || detectBrowserLanguage();
        setSelected(initial);
        if (i18n.language !== initial) {
          i18n.changeLanguage(initial);
        }
      } catch {
        // no-op
      }
    }
  }, [isClient]);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelected(value);
    try {
      if (isClient) {
        localStorage.setItem('lang', value);
      }
    } catch {
      // no-op
    }
    i18n.changeLanguage(value);
  };

  // Return null during SSR to prevent hydration mismatch
  if (!isClient) {
    return null;
  }

  return (
    <div className="mt-4 flex items-center justify-center">
      <label htmlFor="language-select" className="mr-2 text-sm text-gray-600">
        Language
      </label>
      <div className="relative inline-block">
        <select
          id="language-select"
          value={selected}
          onChange={handleChange}
          className="bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 cursor-pointer min-w-[120px]"
        >
          {LANGUAGES.map((l) => (
            <option key={l.code} value={l.code}>{l.label}</option>
          ))}
        </select>
      </div>
    </div>
  );
}


